export default __webpack_public_path__ + "static/alternativeto-icon-29b734b524d4e1826e3828c72dcebcc0.svg";